module.exports = __webpack_public_path__ + "static/media/bingo-ball_05.c9dab89c.png";